import {ReactComponent as BuscarIcon} from '../../../assets/icons/buscar.svg';
import {ReactComponent as ExistIcon} from '../../../assets/icons/activeIcon.svg';
import {ReactComponent as NoExistIcon} from '../../../assets/icons/deleteMateriaGrupo.svg';


export default function InputBuscarMostrar({onKeyUp, name, id, styles="", exist, placeholder="Buscar interactivo..."}) {


    return(
        <div className={`${styles} flex border-2 border-cyan-500 rounded-md bg-gray-200 pl-2 items-center gap-x-2`}>
            <BuscarIcon/>
            <input
                type="text"
                name={name}
                id={id}
                onKeyUp={onKeyUp}
                className='focus:outline-none border-none bg-inherit w-full rounded-r-md focus:rounded-none'
                placeholder={placeholder}
            />
            {exist == true ? 
            <ExistIcon className='mx-2'/>
            : 
            <NoExistIcon className='mx-2'/>
            }
            
        </div>
    )
}